<script>
    export let graph;

    import { onMount } from 'svelte'
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    let json;

    onMount(async () => {
        json = JSON.stringify(graph, null, 4)
    });

    function toggle() {
        try {
            JSON.parse(json);
        } catch(e) {
            alert(e);
        }
        localStorage.data = json;
        dispatch('change', {json: JSON.parse(json)})
    }
</script>

<button on:click={toggle}>use</button>
<textarea  bind:value={json} />


<style>
html, body, textarea {
    padding:0;
    margin: 0;
    box-sizing: border-box;
}   
textarea {
    width: 100vw;
    height: 100vh;
} 
</style>